import React, { useEffect, useState } from "react";
import styles from "./CreateProduct.module.sass";
import TextInput from "../../../components/TextInput";
import nameAndDesc from "../../NewProduct/NameAndDescription/NameAndDescription.module.sass";
import ImageInput from "../../../components/ImageInput";
import { UseApi } from "../../../hooks/use-api";
import Modal from "../../../components/Modal";
import Schedule from "../../../components/Schedule";
import cn from "classnames";
import Icon from "../../../components/Icon";
import { useUser } from "../../../context";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import PrizesModal from "./PrizesModal";
import NftTemplatesModal from "./NFTTemplateModal";
import { GetRaffleDetail } from "../../../Services/lib/nfttemplates";
import raffle from "../../../i11/Raffle";

const Body = ({ local, setLocal, isDisable, editData }) => {
	const { locale } = useUser();

	const [{ isLoading: editLoading }, getRaffleDetail] = UseApi({
		service: GetRaffleDetail,
	});
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [image, setImage] = useState();
	const [prizeFilters, setPrizeFilters] = useState([]);
	const [ntfTemplatesFilters, setNtfTemplatesFilters] = useState();

	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: isOpenTemplate,
		onClose: onCloseTemplate,
		onOpen: onOpenTemplate,
	} = UseDisclosure();

	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();

	const {
		onOpen: endOpen,
		onClose: endClose,
		isOpen: endIsOpen,
	} = UseDisclosure();

	const HandleChange = (img) => {
		setLocal((p) => {
			return {
				...p,
				image: img.core_image_url,
				image_list: img.image_list,
			};
		});
	};

	const edit_ = async () => {
		if (!editData || !editData?._id) return;
		setImage(editData.image);
		setStartDate(editData.startDate ? new Date(editData.startDate) : "");
		setEndDate(editData.endDate ? new Date(editData.endDate) : "");

		// const cr = editData?.criterians.map((e) => {
		// 	return {
		// 		list: [...e.list],
		// 	};
		// });
		// setNtfTemplatesFilters(cr || [[]]);

		setLocal(editData);

		const result = await getRaffleDetail(editData?._id);
		if (result) {
			setLocal(result);
			const prizes = result?.prizes?.map((e) => {
				return {
					name: e.data.name,
					_id: e.data._id,
					type: e.type,
				};
			});
			setNtfTemplatesFilters(result.criterians);
			// console.log(result);
			setPrizeFilters(prizes || []);
			const criterian_ = result?.criterians.map((e) => {
				const list_ = [...e.list.map((g) => g._id)];
				return {
					list: list_,
				};
			});
			setLocal((v) => {
				return {
					...v,
					prizes: [
						...prizes.map((e) => {
							return {
								id: e._id,
								type: e.type,
							};
						}),
					],
					criterians: [...criterian_],
				};
			});
		}
	};
	useEffect(() => edit_(), []);

	return (
		<>
			<div
				className={cn(nameAndDesc.description, {
					[nameAndDesc.Disabled]: isDisable,
				})}
			>
				<TextInput
					disabled={isDisable}
					defaultValue={local?.name || ""}
					className={nameAndDesc.field}
					label={raffle[locale].name}
					name="title"
					type="text"
					onChangeInput={(v) => {
						setLocal((p) => {
							return {
								...p,
								name: v,
							};
						});
					}}
					required
				/>
				<div style={{ marginTop: "24px" }}>
					<TextInput
						disabled={isDisable}
						className={styles.editor}
						label={raffle[locale].desc}
						name="description"
						type="text"
						onChangeInput={(v) => {
							setLocal((p) => {
								return {
									...p,
									description: v,
								};
							});
						}}
						defaultValue={local?.description || ""}
						textarea
						required
					/>
				</div>
			</div>
			<div
				className={cn(styles.price, {
					[nameAndDesc.Disabled]: isDisable,
				})}
				style={{ marginTop: "24px" }}
			>
				<div className={styles.bt14}>{raffle[locale].prizes}</div>
				<div>
					{prizeFilters.map((e, i) => {
						return (
							<div className={cn(`button-stroke ${styles.mr10}`)} key={i}>
								{e?.name}
								<button
									onClick={() => {
										const _list = prizeFilters.filter((x) => x._id !== e._id);
										setPrizeFilters(_list);
										setLocal((v) => {
											return {
												...v,
												prizes: [
													..._list.map((e) => {
														return {
															id: e._id,
															type: e.type,
														};
													}),
												],
											};
										});
									}}
								>
									<Icon name={"close"} size="24" />
								</button>
							</div>
						);
					})}
					<button
						type="button"
						className={cn(`button button-stroke-none `)}
						onClick={onOpen}
					>
						{raffle[locale].add_prizes}
					</button>
				</div>

				<div className={styles.fieldset}>
					<div className={styles.test}>
						<div
							className={cn(styles.field)}
							onClick={() => {
								if (!isDisable) startOpen();
							}}
						>
							<TextInput
								disabled={isDisable}
								label={raffle[locale].start_date}
								name="Start date "
								type="text"
								value={startDate?.toLocaleString()}
								onChangeInput={() => {
									if (!isDisable) startOpen();
								}}
								required
							/>
						</div>
						{isDisable ? null : (
							<button
								type="button"
								className={cn(`button button-stroke-red`)}
								onClick={() => {
									if (!isDisable) setStartDate("");
								}}
							>
								<Icon name="trash" size="24" />
							</button>
						)}
					</div>
					<div className={styles.test}>
						<div
							className={styles.field}
							onClick={() => {
								if (!isDisable) endOpen();
							}}
						>
							<TextInput
								disabled={isDisable}
								label={raffle[locale].end_date}
								name="End date"
								type="text"
								required
								value={endDate?.toLocaleString()}
								onChangeInput={() => {
									if (!isDisable) endOpen();
								}}
							/>
						</div>
						{isDisable ? null : (
							<button
								type="button"
								className={cn(`button button-stroke-red`)}
								onClick={() => {
									if (!isDisable) setEndDate("");
								}}
							>
								<Icon name="trash" size="24" />
							</button>
						)}
					</div>
				</div>
				<br />
				<p>{raffle[locale].criterians}</p>
				<br />
				{ntfTemplatesFilters &&
					ntfTemplatesFilters.map((e, i) => {
						return (
							<div className={styles.nftTemplate} key={i}>
								<div>
									{e &&
										e?.list.map((val, i) => {
											return typeof val === "object" ? (
												<div key={i}>{val.name}</div>
											) : (
												<div key={i}>{val}</div>
											);
										})}
								</div>

								<button
									type="button"
									onClick={() => {
										const criFilter = ntfTemplatesFilters.filter(
											(_, index) => index !== i
										);
										setNtfTemplatesFilters(criFilter);
										setLocal((l) => {
											return {
												...l,
												criterians: [
													...criFilter.map((obj) => {
														return { list: [...obj.list.map((ob) => ob._id)] };
													}),
												],
											};
										});
									}}
								>
									<Icon name="close" size="24" />
								</button>
							</div>
						);
					})}

				<button
					type="button"
					className={cn(`button button-stroke-none `)}
					onClick={onOpenTemplate}
				>
					{raffle[locale].add_cr}
				</button>
				<div className={styles.price} style={{ marginTop: "24px" }}>
					<ImageInput
						isDisabled={isDisable}
						aspect_ratio={1}
						where="TEMPLATES"
						callBack={HandleChange}
						className={styles.field}
						label={raffle[locale].image}
						required
						initial={editData?.image || ""}
					/>
				</div>
			</div>

			<PrizesModal
				isOpen={isOpen}
				onClose={onClose}
				filter={prizeFilters}
				setFilter={setPrizeFilters}
				setLocal={setLocal}
			/>
			{isOpenTemplate && (
				<NftTemplatesModal
					isOpen={isOpenTemplate}
					onClose={onCloseTemplate}
					filter={ntfTemplatesFilters}
					setFilter={setNtfTemplatesFilters}
					setLocal={setLocal}
				/>
			)}
			{/* // open date modl */}
			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					onClick={startClose}
					startDate={startDate}
					setStartDate={(date) => {
						setLocal((p) => {
							return {
								...p,
								startDate: date,
							};
						});

						setStartDate(date);
					}}
				/>
			</Modal>
			<Modal visible={endIsOpen} onClose={endClose}>
				<Schedule
					onClick={endClose}
					startDate={endDate}
					setStartDate={(date) => {
						setLocal((p) => {
							return {
								...p,
								endDate: date,
							};
						});

						setEndDate(date);
					}}
				/>
			</Modal>
		</>
	);
};

export default Body;
